<ng-container *ngIf="permConfig.isEditAllowed">
<div class="container-fluid">
  <app-page-title title="Edit User"></app-page-title>
  <form [formGroup]="userForm">
    <div class="row">
      <div class="col-8 d-flex flex-column flex-grow-1">
          <div class="card flex-grow-1">
              <div class="card-body">
                  <div class="row">
                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="usergroups" class="form-label">User Group<span class="mandatory">*</span></label>
                              <ng-select id="usergroups" formControlName="ddlGroups" [items]="userGroupList"
                                  [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" placeholder="Select" [clearable]="false"
                                  (change)="onUserGroupChange($event)"
                                  class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                  [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlGroups').touched) && userForm.get('ddlGroups').errors}" 
                                 (keydown.enter)="useEnterKey && userForm.get('ddlGroups').valid ? roleRef.focus() : userForm.get('ddlGroups').markAsTouched()" >
                              </ng-select>
                              <div *ngIf="(isFormSubmitted || userForm.get('ddlGroups').touched) && userForm.get('ddlGroups').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('ddlGroups').errors.required">User Group is required</span>
                              </div>
                          </div>
                      </div>

                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="roles" class="form-label">Role<span class="mandatory">*</span></label>
                              <ng-select #roleRef id="roles" formControlName="ddlRoles" [items]="filteredRoleList" [clearable]="false"
                                  [appendTo]="'body'" [openOnEnter]="false" bindLabel="rolename" [bindValue]="'id'" placeholder="Select"
                                  class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                  [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlRoles').touched) && userForm.get('ddlRoles').errors}" 
                                 (keydown.enter)="useEnterKey && userForm.get('ddlRoles').valid ? loginType.focus() : userForm.get('ddlRoles').markAsTouched()" >
                              </ng-select>
                              <div *ngIf="(isFormSubmitted || userForm.get('ddlRoles').touched) && userForm.get('ddlRoles').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('ddlRoles').errors.required">Role is required</span>
                              </div>

                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="logintype" class="form-label">Login Type <span
                                  class="mandatory">*</span></label>
                              <ng-select #loginType id="logintype" formControlName="ddlLoginType" [items]="loginTypeList"
                                  [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" placeholder="Select" [clearable]="false"
                                  (change)="onLoginTypeChange($event)"
                                  [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlLoginType').touched) && userForm.get('ddlLoginType').errors}" 
                                 (keydown.enter)="useEnterKey && userForm.get('ddlLoginType').valid ? companyRef.focus() : userForm.get('ddlLoginType').markAsTouched()" >
                              </ng-select>
                              <div *ngIf="(isFormSubmitted || userForm.get('ddlLoginType').touched) && userForm.get('ddlLoginType').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('ddlLoginType').errors.required">Login type is
                                      required</span>
                              </div>
                          </div>
                      </div>

                      <ng-container *ngIf="selectedLoginType === 'Client'">
                        <div class="col-md-6">
                            <div class="mb-2">
                                <label for="company" class="form-label">Company<span class="mandatory">*</span></label>
                                <ng-select #companyRef id="company" formControlName="ddlCompany" [items]="companyList"
                                    [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" [multiple]="true"
                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                    placeholder="Select" (change)="onCompanyChange($event)"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlCompany').touched) && userForm.get('ddlCompany').errors}" 
                                    (keydown.enter)="useEnterKey && userForm.get('ddlCompany').valid ? utilities.closeCurrentAndFocusNext(companyRef, userNameRef) : userForm.get('ddlCompany').markAsTouched()">
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || userForm.get('ddlCompany').touched) && userForm.get('ddlCompany').errors" class="invalid-feedback">
                                    <span *ngIf="userForm.get('ddlCompany').errors.required">Company is required</span>
                                  </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="selectedLoginType === 'Customer'">
                        <div class="col-md-6">
                            <div class="mb-2">
                                <label for="customer" class="form-label">Customer<span class="mandatory">*</span></label>
                                <ng-select #customerRef id="customer" formControlName="ddlCustomer" [items]="customerList"
                                    [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'"
                                    placeholder="Select" 
                                    [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlCustomer').touched) && userForm.get('ddlCustomer').errors}" 
                               (keydown.enter)="useEnterKey && userForm.get('ddlCustomer').valid ? userNameRef.focus() : userForm.get('ddlCustomer').markAsTouched()" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || userForm.get('ddlCustomer').touched) && userForm.get('ddlCustomer').errors" class="invalid-feedback">
                                    <span *ngIf="userForm.get('ddlCustomer').errors.required">Customer is required</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                  </div>
                  <div class="row">
                      <div class="col-md-3">
                          <div class="mb-2">
                            <label for="userName" class="form-label">User Name <span class="mandatory">*</span></label>
                            <input #userNameRef type="text" class="form-control form-control-sm" maxlength="100" autocomplete="off"
                              name="randomized-username"
                              formControlName="txtUserName" id="userName"
                              [ngClass]="{ 'is-invalid': (isFormSubmitted || userForm.get('txtUserName').touched) && userForm.get('txtUserName').errors}" 
                                 (keydown.enter)="useEnterKey && userForm.get('txtUserName').valid ? emailIdRef.focus() : userForm.get('txtUserName').markAsTouched()" />
                            <div *ngIf="(isFormSubmitted || userForm.get('txtUserName').touched) && userForm.get('txtUserName').errors"
                              class="invalid-feedback">
                              <span *ngIf="userForm.get('txtUserName').errors.required">User Name is required</span>
                              <span *ngIf="userForm.get('txtUserName').errors.maxlength">Maximum length exceeded (100 characters).</span>
                              <span *ngIf="userForm.get('txtUserName').errors.pattern">Invalid input. Use only letters and numbers.</span>
                            </div>
                          </div>
                        </div>

                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="EmailId" class="form-label">Email Id <span class="mandatory">*</span></label>
                              <input #emailIdRef type="text" class="form-control form-control-sm" 
                                  id="EmailId" maxlength="100" formControlName="txtEmailId"
                                  [ngClass]="{ 'is-invalid': (isFormSubmitted || userForm.get('txtEmailId').touched) && userForm.get('txtEmailId').errors }" 
                                 (keydown.enter)="useEnterKey && userForm.get('txtEmailId').valid ? deviceTypeRef.focus() : userForm.get('txtEmailId').markAsTouched()"/>
                              <div *ngIf="(isFormSubmitted || userForm.get('txtEmailId').touched) && userForm.get('txtEmailId').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('txtEmailId').errors.required">Email is
                                      required</span>
                                  <span *ngIf="userForm.get('txtEmailId').errors.pattern">Invalid Email
                                      Format</span>
                                  <span *ngIf="userForm.get('txtEmailId').errors.maxlength">Maximum length
                                      exceeded (100
                                      characters).</span>
                              </div>
                          </div>
                      </div>

                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="devicetype" class="form-label">Device Type <span
                                  class="mandatory">*</span></label>
                              <ng-select #deviceTypeRef id="devicetype" formControlName="ddlDeviceType" [items]="deviceTypeList"
                                  [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" placeholder="Select" [clearable]="false"
                                  (change)="onDeviceTypeChange($event)"
                                  [ngClass]="{'is-invalid': (isFormSubmitted || userForm.get('ddlDeviceType').touched) && userForm.get('ddlDeviceType').errors}" 
                                 (keydown.enter)="useEnterKey && userForm.get('ddlDeviceType').valid ? mobileNoRef.focus() : userForm.get('ddlDeviceType').markAsTouched()" >
                              </ng-select>
                              <div *ngIf="(isFormSubmitted || userForm.get('ddlDeviceType').touched) && userForm.get('ddlDeviceType').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('ddlDeviceType').errors.required">Device type is
                                      required</span>
                              </div>
                          </div>
                      </div>

                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="mobileno" class="form-label">Mobile No.</label>
                              <input #mobileNoRef type="number" class="form-control form-control-sm" id="mobileno"
                                  formControlName="txtMobileNo"
                                  [ngClass]="{ 'is-invalid': (isFormSubmitted || userForm.get('txtMobileNo').touched) && userForm.get('txtMobileNo').errors }" appLimitDigits [length] = "10" 
                                 (keydown.enter)="useEnterKey && userForm.get('txtMobileNo').valid ? status.focus() : userForm.get('txtMobileNo').markAsTouched()" />
                              <div *ngIf="(isFormSubmitted || userForm.get('txtMobileNo').touched) && userForm.get('txtMobileNo').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="userForm.get('txtMobileNo').errors.pattern">Must be of 10 Digits.</span>
                                  <!-- <span *ngIf="userForm.get('txtMobileNo').errors.required">Mobile No. is
                                      required</span> -->
                              </div>
                          </div>
                      </div>

                  </div>
                    
                  <div class="row">
                      <div class="col-md-3">
                          <div class="mb-2">
                              <label for="status" class="form-label">Status </label>
                              <div class="form-check form-switch form-switch-md mb-2">
                                  <input #status type="checkbox" id="SwitchCheckSizemd" class="form-check-input" 
                                      (keydown.enter)="SubmitBtn.focus()"
                                      formControlName="txtStatus" [checked]="userForm.get('txtStatus').value" />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-4 d-flex flex-column flex-grow-1">
          <div class="card flex-grow-1">
              <div class="card-header bg-transparent border-bottom">
                  Service Centers
              </div>
              <div class="card-body">
                  <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                      class="ag-theme-balham" [rowData]="serviceCenterRowData" [columnDefs]="serviceCenterColumnDefs"
                      [animateRows]="true" [context]="context"
                      [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                      (gridReady)="onGridReady($event)" (keydown.enter)="SubmitBtn.focus()">
                  </ag-grid-angular>
              </div>
          </div>
      </div>
  </div>
    <div class="button-items">
      <button #SubmitBtn type="button" class="btn btn-primary w-sm" (click)="updateUser()" (keydown.enter)="updateUser()">Update</button>
      <a routerLink="/iam/users"><button type="button" class="btn btn-secondary w-sm">Cancel</button></a>
    </div>
    <input style="display:none" type="text" autocomplete="username">
    <input style="display:none" type="password" autocomplete="new-password">
    <input style="display:none" type="text" autocomplete="email">
  </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isEditAllowed">
  <app-forbidden></app-forbidden>
</ng-container>